<!-- template -->
<div class="card m-0 bg-transparent">
  <div class="card-body">
    <form [formGroup]="labelform">

      <!-- Corner Position -->
      <div class="col-12 mb-3">
        <label class="offcanvas-header-text w-100 text-start mb-2">
          Corner Position
        </label>
        <div class="row g-2">
          <div class="col-3" *ngFor="let c of cornerOptions">
            <button
              type="button"
              class="btn w-100 d-flex flex-column align-items-center gap-1 py-2 px-1"
              [class.btn-outline-light]="labelform.get('position')?.value !== c.key"
              [class.btn-outline-primary]="labelform.get('position')?.value === c.key"
              (click)="selectCorner(c.key)"
            >
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <rect
                  x="2" y="2" width="24" height="24" rx="2"
                  [attr.stroke]="labelform.get('position')?.value === c.key ? '#0d6efd' : '#6c757d'"
                  stroke-width="1.5"
                />
                <path
                  *ngIf="c.tl"
                  d="M2 10 Q2 2 10 2"
                  [attr.stroke]="labelform.get('position')?.value === c.key ? '#0d6efd' : '#6c757d'"
                  stroke-width="2.5" fill="none" stroke-linecap="round"
                />
                <path
                  *ngIf="c.tr"
                  d="M18 2 Q26 2 26 10"
                  [attr.stroke]="labelform.get('position')?.value === c.key ? '#0d6efd' : '#6c757d'"
                  stroke-width="2.5" fill="none" stroke-linecap="round"
                />
                <path
                  *ngIf="c.br"
                  d="M26 18 Q26 26 18 26"
                  [attr.stroke]="labelform.get('position')?.value === c.key ? '#0d6efd' : '#6c757d'"
                  stroke-width="2.5" fill="none" stroke-linecap="round"
                />
                <path
                  *ngIf="c.bl"
                  d="M10 26 Q2 26 2 18"
                  [attr.stroke]="labelform.get('position')?.value === c.key ? '#0d6efd' : '#6c757d'"
                  stroke-width="2.5" fill="none" stroke-linecap="round"
                />
              </svg>
              <span
                class="text-truncate w-100 text-center"
                style="font-size:10px"
              >
                {{ c.label }}
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Corner Size -->
      <div class="col-12">
        <label class="offcanvas-header-text w-100 text-start mb-2">
          Corner Size
        </label>
        <div class="input-group">
          <input
            type="number"
            formControlName="size"
            placeholder="Corner Size"
            class="form-control offcanvas-primary border-0"
            (change)="changeSize()"
          />
          <span
            class="input-group-text border-0 offcanvas-primary"
            style="font-family: monospace; font-size:12px;"
          >
            {{ (labelform.get('size')?.value || 0) / 16 | number:'1.0-4' }}rem
          </span>
        </div>
      </div>

    </form>
  </div>
</div>
